import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { toast } from "sonner";
import axios from "axios";
import Cookies from "js-cookie";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const res = await axios.post(`${API}/admin/login`, { password });
            if (res.data.success) {
                Cookies.set("admin_auth", password, { expires: 1 });
                navigate("/admin/dashboard");
            }
        } catch (e) {
            toast.error("Invalid password");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-background flex items-center justify-center p-6">
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                className="w-full max-w-md"
            >
                <div className="text-center mb-8">
                    <div className="w-16 h-16 mx-auto mb-6 bg-primary/20 flex items-center justify-center">
                        <Lock className="w-8 h-8 text-primary" />
                    </div>
                    <h1 className="font-heading text-3xl font-bold mb-2">Admin Access</h1>
                    <p className="text-muted-foreground">
                        Enter your password to access the dashboard
                    </p>
                </div>

                <form onSubmit={handleLogin} className="space-y-4">
                    <Input
                        type="password"
                        placeholder="Admin password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="h-12 bg-input border-border text-foreground"
                        data-testid="admin-password-input"
                    />
                    
                    <Button 
                        type="submit"
                        disabled={isLoading}
                        className="btn-primary w-full h-12"
                        data-testid="admin-login-button"
                    >
                        {isLoading ? (
                            <span className="flex items-center gap-2">
                                <div className="w-5 h-5 border-2 border-black border-t-transparent rounded-full animate-spin" />
                                Verifying...
                            </span>
                        ) : (
                            <>
                                Access Dashboard
                                <ArrowRight className="ml-2 w-5 h-5" />
                            </>
                        )}
                    </Button>
                </form>

                <p className="text-center text-sm text-muted-foreground mt-6">
                    Default password: admin123
                </p>
            </motion.div>
        </div>
    );
};

export default AdminLogin;
